import { render, staticRenderFns } from "./VerticalNavigation.vue?vue&type=template&id=a0187022&"
import script from "./VerticalNavigation.vue?vue&type=script&lang=js&"
export * from "./VerticalNavigation.vue?vue&type=script&lang=js&"
import style0 from "./vertical-navigation.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports